import { DurabilityTaxonomyAlignment } from '../../../../types';
export var list = [
    DurabilityTaxonomyAlignment.FIVE_PERCENT,
    DurabilityTaxonomyAlignment.TEN_PERCENT,
    DurabilityTaxonomyAlignment.FIFTEEN_PERCENT,
    DurabilityTaxonomyAlignment.TWENTY_PERCENT,
];
